<template>
  <Transition name="peekaboo">
    <nav
      v-if="isVisible"
      class="navigation-top"
      :class="{ '-has-announcement': hasLiveEvent && !$device.laptop, '-offset-top': showAnnouncement }"
    >
      <section class="navigation-top__container">
        <LocaleLink v-appear:right :to="{ name: 'home' }" class="navigation-top__logo -small">
          <img :src="$t('common.logoSmall')" alt="Logo" />
        </LocaleLink>

        <nav class="navigation-top__list">
          <LocaleLink
            v-appear="{ delay: 100 }"
            :to="{ name: 'home' }"
            class="navigation-top__item"
            exact
            @click.native="onClickPage('home')"
          >
            {{ $t('common.navigation.home') }}
          </LocaleLink>
          <LocaleLink
            v-appear="{ delay: 150 }"
            :to="{ name: 'events-annual' }"
            class="navigation-top__item"
            :class="{ '-active': isEventPage }"
            @click.native="onClickPage('events-annual')"
          >
            {{ $t('common.navigation.eventsAnnual') }}
          </LocaleLink>
          <LocaleLink
            v-appear="{ delay: 200 }"
            :to="{ name: 'events' }"
            class="navigation-top__item"
            @click.native="onClickPage('events')"
          >
            {{ $t('common.navigation.allEvents') }}
          </LocaleLink>
          <LocaleLink
            v-appear="{ delay: 250 }"
            :to="{ name: 'team' }"
            class="navigation-top__item"
            @click.native="onClickPage('team')"
          >
            {{ $t('common.navigation.teamShort') }}
          </LocaleLink>
          <LocaleLink
            v-appear="{ delay: 300 }"
            :to="{ name: 'home', hash: '#contact' }"
            class="button navigation-top__item"
          >
            {{ $t('common.cta.contact') }}
          </LocaleLink>

          <template v-for="lang in langLinks">
            <RouterLink :key="lang" v-appear="{ delay: 300 }" :to="getLangLink(lang)" class="navigation-top__lang">
              <span class="navigation-top__item -link -alt">{{ lang.toUpperCase() }}</span>
            </RouterLink>
          </template>
        </nav>

        <div class="navigation-top__burger" @click="$emit('toggle-sidenav')">
          <svg-icon id="menu" />
        </div>
      </section>

      <section v-if="isEventPage" v-appear:down="{ delay: 100 }" class="navigation-top__sub">
        <section class="navigation-top__container">
          <LocaleLink :to="{ name: 'conference', params: { slug } }" class="navigation-top__subtile">
            {{ conference.name }}
          </LocaleLink>

          <a v-if="siteLink" :href="siteLink" target="_blank" class="link -bold -icon">
            <p>{{ $t('common.cta.registerNow') }}</p>
            <svg-icon id="arrow" />
          </a>
        </section>
      </section>
    </nav>
  </Transition>
</template>

<script>
import moment from 'moment'
import getLocalizedRoute from '@/helpers/getLocalizedRoute'

export default {
  name: 'NavigationTop',
  props: {
    hasLiveEvent: Boolean
  },
  data() {
    return {
      isVisible: false,
      eventRouteNames: ['toronto', 'miami', 'paris', 'buenos-aires', 'phoenix', 'montreal']
    }
  },
  computed: {
    langLinks() {
      return ['en', 'fr'].filter(lang => lang !== this.$i18n.locale)
    },
    isEventPage() {
      return this.conference
    },
    slug() {
      return this.$route.params.slug
    },
    conference() {
      return this.$i18n.messages[this.$i18n.locale].conferences[this.slug]
    },
    siteLink() {
      const nextEvent = this.conference.events.find(({ startDate }) => moment(startDate).isAfter(moment()))
      return nextEvent && (nextEvent.registerLink || nextEvent.siteLink)
    },
    showAnnouncement() {
      return this.hasLiveEvent && !this.$device.laptop && this.$scroll.position < 2 && !this.isEventPage
    }
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler() {
        if (this.isEventPage) this.isVisible = true
        else this.updateVisibility(this.$scroll.position)
      }
    },
    '$device.laptop': {
      immediate: true,
      handler(isLaptop) {
        if (!isLaptop) this.isVisible = true
        else this.updateVisibility(this.$scroll.position)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$scroll.on(this.updateVisibility)
    })
  },
  methods: {
    updateVisibility(position) {
      if (!this.$device.laptop || this.isEventPage) return
      this.isVisible = position > 72
    },
    getLangLink(lang) {
      const link = getLocalizedRoute(lang, this.$route)
      return link
    },
    onClickPage(name) {
      if (this.$route.name.includes(name)) this.$scroll.toTop()
    }
  }
}
</script>

<style lang="scss">
.peekaboo {
  &-enter-active,
  &-leave-active {
    transition: transform 240ms cubic-bezier(0.6, 0.05, 0.01, 0.99), opacity 120ms linear;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  &-leave,
  &-enter-to {
    transform: translateZ(0);
  }
}
</style>
